export default __webpack_public_path__ + "static/5fe161deb43fe5c2b3a08b5dcc522225.png";